import { DataCategory } from '../../../shared/api/api';
import { TableDataCategory } from './types';

export const findNestedCategory = (categories: DataCategory[] = [], id: string): DataCategory | undefined => {
  const found = categories.find(category => category.id === id);

  if (found) {
    return found;
  }

  for (const category of categories) {
    const foundInner = findNestedCategory(category.children, id);
    if (foundInner) {
      return foundInner;
    }
  }
};

const TREE_TABLE_ROW_HEIGHT = 50;

export function prepareCategoriesForTable(dataCategories: any[], parent?: any[]) {
  const outputCategories: { data: TableDataCategory }[] = [];

  dataCategories.forEach(category => {
    const { children, ...data } = category;

    const outputCategory = {
      height: TREE_TABLE_ROW_HEIGHT,
      data: {
        ...data,
        _parent: parent ? { ...parent, children: [] } : undefined,
      },
      children: children ? prepareCategoriesForTable(children, { ...data }) : [],
    };

    outputCategories.push(outputCategory);
  });

  return outputCategories;
}
